import { GlobalControl } from '@hb/domain';
import { CoApplicantPipe } from '@hb/modules/global';
import { AnalyticsService } from '@hb/services/analytics/analytics.service';
import { DateOfBirthStoreService } from '@hb/modules/applicants/date-of-birth/date-of-birth-store.service';
import { QuestionKey } from '@hb/modules/global/global.constants';
import { AdditionalInfoComponent, NextButtonComponent } from '@hb/modules';
import { getMaxDate, getMinDate } from '@hb/modules/applicants/applicants.constants';
import { CO_QUESTION_KEY, GLOBAL_STORE, GlobalInjectComponent, QUESTION_KEY } from '@hb/modules/global/abstract-global-inject.component';

import { Component, inject, OnInit } from '@angular/core';
import { distinctUntilChanged, skip } from 'rxjs';
import { ReactiveFormsModule } from '@angular/forms';

import { ApContentModule } from '@ap/content';
import { ApDateInputComponent } from '@ap/input/date';

@Component({
    selector: 'date-of-birth',
    templateUrl: './date-of-birth.component.html',
    standalone: true,
    imports: [ApContentModule, ReactiveFormsModule, ApDateInputComponent, AdditionalInfoComponent, NextButtonComponent, CoApplicantPipe],
    providers: [
        { provide: GLOBAL_STORE, useExisting: DateOfBirthStoreService },
        { provide: QUESTION_KEY, useValue: QuestionKey.INCOME_MAIN_APPLICANT_DATE_OF_BIRTH },
        { provide: CO_QUESTION_KEY, useValue: QuestionKey.INCOME_CO_APPLICANT_DATE_OF_BIRTH }
    ]
})
export class DateOfBirthComponent extends GlobalInjectComponent<DateOfBirthStoreService> implements OnInit {
    protected readonly analyticsService = inject(AnalyticsService);
    protected readonly store = inject(DateOfBirthStoreService);

    protected readonly minDate: Date = getMinDate();
    protected readonly maxDate: Date = getMaxDate();

    constructor() {
        super();
    }
    ngOnInit(): void {
        this.mainApplicantControl = new GlobalControl<Date>(
            this.analyticsService,
            this.questionKey,
            this.store.getMainApplicantDateOfBirth()
        );
        this.mainApplicantControl.onUpdate().subscribe((date: Date) => this.store.setMainApplicantDateOfBirth(date));

        this.coApplicantControl = new GlobalControl<Date>(
            this.analyticsService,
            this.coQuestionKey,
            this.store.getCoApplicantDateOfBirth()
        );

        this.store
            .getHasCoApplicant()
            .pipe(distinctUntilChanged(), skip(1))
            .subscribe((hasCoApplicant) => {
                if (!hasCoApplicant) {
                    this.coApplicantControl.setValue(null);
                }
            });
        this.coApplicantControl.onUpdate().subscribe((date: Date) => this.store.setCoApplicantDateOfBirth(date));
    }
}
